import { useCallback, useEffect, useRef, useState } from "react";
import { getAdminCommunityMastermind } from "../../services/membersAdminService";
import { CommunityPost } from "./models/CommunityPost";

interface APITableResult<T> {
    count: number;
    next: T | null;
    previous: T | null;
    results: T[];
}

export const useCommunityMemeberMastermind = (userId: number, reloadKey?: number) => {
    const isMountedRef = useRef(true);
    const [loading, setLoading] = useState(false);
    const [mastermind, setMastermind] = useState<CommunityPost[]>([]);
    const [mastermindPage, setMastermindPage] = useState(1);
    const [mastermindTotalPages, setMastermindTotalPages] = useState(0);
    
    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        }
    }, []);

    const totalPages = (count: number) => Math.ceil(count / 5);

    const load = useCallback(async () => {
        if(!userId)
            return;
        try {
            setLoading(true);
            const _mastermind = await getAdminCommunityMastermind(userId, mastermindPage-1) as APITableResult<CommunityPost>;
            if(!isMountedRef.current)
                return;

            if(!!_mastermind){
                setMastermind(_mastermind.results);
                setMastermindTotalPages(totalPages(_mastermind.count));
            }

        }
        finally {
            if(!isMountedRef.current)
                return;
            setLoading(false);
        }
    }, [userId, mastermindPage, reloadKey]);

    useEffect(() => {
        load();
    }, [load]);

    return { 
        loading, 
        mastermind, 
        mastermindPage,
        mastermindTotalPages,
        setMastermindPage,
    }
}